<template>
  <article :class="['review-card', reviewItemStyles]">
    <div :class="['review-card__score', { 'review-card__score--large': largeHeading }]">
      <span class="review-card__score__numerator" v-text="expertReviewData.Score" /> <span class="review-card__score__denominator">/ 10</span>
    </div>
    <div class="review-card__content">
      <component :is="largeHeading ? 'h2' : 'p'" :class="largeHeading ? 'no-margin large-heading' : 'text-bold mb-1 mt-0'">
        Car review <img :src="RACQSmileIcon" alt="An icon of the RACQ logo ribbon." class="ribbon-icon" />
      </component>

      <p class="review-categories">Average rating across {{ reviewCategoriesLength }} assessment categories</p>
      <ExplanationModal
        :with-icon="true"
        button-text="Explanation"
        :title="expertReviewModalContent.title.value"
        :description="expertReviewModalContent.description.value"
      />
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ExplanationModal from '../modals/ExplanationModal.vue';
import RACQSmileIcon from '../../assets/img/racq-smile.svg';
import { useContentStore } from '../../foundation/stores/contentStore';

const props = defineProps({
  expertReviewData: {
    type: Object,
    default: () => ({}),
  },
  apiStatus: {
    type: String,
    default: 'LOADING',
  },
  largeHeading: {
    type: Boolean,
    default: false,
  },
});

const reviewCategoriesLength = computed(() => Object.keys(props.expertReviewData.CategoryScore ?? {}).length || 0);
const reviewItemStyles = computed(() => [
  {
    'skeleton-box': props.apiStatus === 'LOADING',
    'white-card': props.apiStatus !== 'LOADING',
    'large-height': props.largeHeading,
  },
]);

const contentStore = useContentStore();
contentStore.fetchModalDatasources();
const expertReviewModalContent = contentStore.modalDatasources?.modalContentItems?.expertReview;
</script>

<style lang="scss" scoped>
.review-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 100%;

  .ribbon-icon {
    vertical-align: bottom;
    padding-left: 0.5rem;
  }

  &.large-height {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .large-heading {
    line-height: 1;
    font-size: 1.5rem;

    @media screen and (min-width: #{$breakpoint-lg}) {
      font-size: 2rem;
    }

    .ribbon-icon {
      vertical-align: baseline;
    }
  }

  .review-categories {
    margin: 0;
    padding-bottom: 0.5rem;
    padding-top: 0.25rem;
    line-height: 1.25;
  }

  &__score {
    border-radius: 50%;
    background: $racq-pale-blue;
    border: 1px solid $racq-pale-blue-border;
    min-width: 4.375rem;
    min-height: 4.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $racq-navy;

    &__numerator {
      font-size: 1.75rem;
      font-family: $firasans-semibold-font;
      letter-spacing: -1px;
    }

    &--large {
      min-width: 5.25rem;
      min-height: 5.25rem;

      .review-card__score__numerator {
        font-size: 2rem;
      }
    }

    &__denominator {
      font-size: 0.875rem;
      letter-spacing: -2px;
      position: relative;
      bottom: 0.25rem;
      padding: 0.25rem;
    }
  }
}

.loading {
  * {
    opacity: 0;
  }
}
</style>
